import React from 'react';
import { useServiceActionContext } from '../mitSundhed/mitSundhedCredit/ServiceActionProvider';
import PaymentFlow from './PaymentFlow';

const PaymentFlowWrapper = () => {
  const { paymentFlowProps } = useServiceActionContext();

  if (!paymentFlowProps) {
    console.error('PaymentFlow must be used within a ServiceActionProvider.');
  }

  return <PaymentFlow {...paymentFlowProps} />;
};

export default PaymentFlowWrapper;
